/**
 * A global namespace for `offsetHeight` property.
 */
const offsetHeight = "offsetHeight";
export default offsetHeight;
